export const stripStringAndAppendEllipsis = (str: string, stripSize: number) :string => {
    let newString = str;
    if (newString.length > stripSize) {
       return newString.substring(0, stripSize) + "..."
    } 
    return newString;
}

export const ordinal = (number: number) => {
    var i = number % 10;
    var ii = number % 100;

    if ((ii >= 11 && ii <= 13) || i === 0 || i >= 4) {
        return 'th';
    }
    switch (i) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
    }
}

export const isSpringboardEligibleByDate = (): boolean => {
    const now = new Date();
    return now >= new Date('2026-04-01') && now <= new Date('2026-05-17');
}

export const isSpringboardEnrollmentEligible = (): boolean => {
    const now = new Date();
    return now >= new Date('2026-04-01') && now <= new Date('2026-05-10');
}